import { request } from './index'
import type { PageResponse } from './index'
import type {
  FavoriteItem,
  FavoriteQuery,
  AddFavoriteParams,
  FavoriteStatistics,
  FavoriteType
} from '@/types/favorite'

export const favoriteApi = {
  // 获取用户收藏列表(分页)
  getFavoritePage(userId: number, params: FavoriteQuery) {
    return request.get<PageResponse<FavoriteItem>>(`/favorite/user/${userId}/page`, { params })
  },

  // 获取用户所有收藏
  getUserFavorites(userId: number, itemType?: FavoriteType) {
    return request.get<FavoriteItem[]>(`/favorite/user/${userId}`, {
      params: { itemType }
    })
  },

  // 添加收藏
  addFavorite(userId: number, params: AddFavoriteParams) {
    return request.post<FavoriteItem>(`/favorite/user/${userId}`, params)
  },

  // 取消收藏
  removeFavorite(userId: number, favoriteId: number) {
    return request.delete(`/favorite/user/${userId}/${favoriteId}`)
  },

  // 根据商品ID取消收藏
  removeFavoriteByItem(userId: number, itemId: number, itemType: FavoriteType) {
    return request.delete(`/favorite/user/${userId}/item/${itemId}`, {
      params: { itemType }
    })
  },

  // 批量添加收藏
  addMultipleFavorites(userId: number, items: AddFavoriteParams[]) {
    return request.post<FavoriteItem[]>(`/favorite/user/${userId}/batch`, items)
  },

  // 批量取消收藏
  removeMultipleFavorites(userId: number, favoriteIds: number[]) {
    return request.delete(`/favorite/user/${userId}/batch`, {
      data: favoriteIds
    })
  },

  // 检查是否已收藏
  isFavorited(userId: number, itemId: number, itemType: FavoriteType) {
    return request.get<boolean>(`/favorite/user/${userId}/check`, {
      params: { itemId, itemType }
    })
  },

  // 获取收藏统计
  getFavoriteStatistics(userId: number) {
    return request.get<FavoriteStatistics>(`/favorite/user/${userId}/statistics`)
  },

  // 清空用户收藏
  clearFavorites(userId: number, itemType?: FavoriteType) {
    return request.delete(`/favorite/user/${userId}/clear`, {
      params: { itemType }
    })
  },

  // 获取最近收藏
  getRecentFavorites(userId: number, limit = 10) {
    return request.get<FavoriteItem[]>(`/favorite/user/${userId}/recent`, {
      params: { limit }
    })
  }
}
